import {
  CUSTOMER_ACCOUNT_AGREEMENT_DESER,
  CustomerAccountAgreement,
} from "../../tastyworks/document"
import type HttpClient from "../../tastyworks/http"
import { parseItemsResponse } from "../../tastyworks/response"

export class AccountAgreementService {
  constructor(private readonly accountNumberClient: HttpClient) {}

  readonly create = async (
    accountNumber: string,
    agreements: { slug: string }[]
  ) => {
    const helper = await this.accountNumberClient.postJson(
      "agreements",
      {
        agreements,
        "acceptance-method": "Click",
      },
      { accountNumber }
    )

    return parseItemsResponse(
      helper,
      CUSTOMER_ACCOUNT_AGREEMENT_DESER.toParser(CustomerAccountAgreement)
    )
  }
}
